import React from 'react';
import { Checkbox, Icon } from '@fluentui/react';
import Api from '../../../services/Api'

class TreeComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = ({
            Children: [],
            MyChildrenExpanded: false
        })
    }

    fitPossibilities(posts) {
        this.setState({ Children: posts })
    }

    amIselected() {
        return this.props.isMultiValue
            ? this.props.selectedItem.some(x => x.key === this.props.child.key)
            : this.props.selectedItem && this.props.selectedItem.key === this.props.child.key
    }

    handleExpansion() {
        if (!this.state.MyChildrenExpanded) {
            // let depth = Number(this.props.child.depth) + 1;
            const treeDataFixedUrl = this.props.url.indexOf('?') > -1 ? `${this.props.url}&` : `${this.props.url}?`
            
            Api.get(treeDataFixedUrl + 'parent=' + this.props.child.key)
                .then(res => res.data)
                .then(posts => {
                    this.fitPossibilities(posts);
                });
        }
        this.setState({ MyChildrenExpanded: !this.state.MyChildrenExpanded });
    }

    handleSelection = () => {
        if (!this.props.isMultiValue)
            this.props.itemSelector(this.props.child)
        else
            this.props.itemSelector(!this.amIselected() ? [...this.props.selectedItem, this.props.child] : this.props.selectedItem.filter(x => x.key !== this.props.child.key))
    }

    getTextFromItem(item: ITag): string {
        return !this.props.keyHidden && item.key !== item.value && item.key !== 'Cross' ? `${item.key} - ${item.value}` : item.value;
    }

    isChildrenSelected(item) {
        if (this.amIselected() || !this.props.selectedItem || this.props.selectedItem.length === 0 || !item.childrenKeys)
            return false
        
        return this.props.isMultiValue
            ? this.props.selectedItem.some(x => item.childrenKeys.includes(x.key))
            : item.childrenKeys.includes(this.props.selectedItem.key)
    }

    render() {
        const selection = this.amIselected();
        const margin = this.props.child.depth * 10;
        const children = this.state.Children.map(item => 
            <div key={item.key} style={{ marginLeft: margin + 'px' }}>
                <TreeComponent
                    key={item.key}
                    child={item}
                    itemSelector={this.props.itemSelector}
                    selectedItem={this.props.selectedItem}
                    url={this.props.url}
                    isParent = {item.isParent}
                    keyHidden={this.props.keyHidden}
                    isMultiValue={this.props.isMultiValue}
                />
            </div>
        )
        const showChildren = this.state.MyChildrenExpanded ? <div className='children'> {children} </div> : null;
        const expandIconVisibility = {
            visibility: this.props.child.isParent ? 'visible' : 'hidden'
        };

        return (
            <div className='wizard-item'>
                <div onClick={this.handleExpansion.bind(this)} className="expand-icon" style={expandIconVisibility} >
                    <Icon iconName="CaretHollow" />
                </div>
                <Checkbox id={this.props.child.key} label={this.getTextFromItem(this.props.child)} checked={selection} onChange={this.handleSelection} indeterminate={this.isChildrenSelected(this.props.child)} />
                <div className='wizard-item'>
                    {showChildren}
                </div>
            </div>
        );
    }
}



export default TreeComponent








// WEBPACK FOOTER //
// ./src/components/CreateSite/CommonComponents/TreeComponent.js